import { Notify } from "vant";
import axios from "axios";
import VueCookie from "vue-cookie";
import Vue from "vue";
import store from "../../store/index";
import router from "../../router/index";

const securedPaths = ["/mobile/paymentsTest", "/mobile/payments"];
const retryPaths = ["/mobile/chat", "/mobile/self"];
const codeList = {
  BINDFA: 10016,
};

const domainTitleMap = {
  "pay.zhaofupay.com": "https://i.zhaofupay.com",
  "runn-f.test": "/", // 本機測試
  "running.etmart2.test": "/", // 本機測試
  "running.etmart2.com": "/", // 測試機測試
  "running.etmart3.com": "/", // 測試機測試
  "43.139.102.188": "http://43.139.102.188", // 聚合支付
  "43.138.153.196": "http://43.138.153.196", // 海淘
  "122.152.225.41": "http://122.152.225.41", // 天運
  "119.91.195.29": "http://119.91.195.29", // Li
  "42.194.148.159": "http://42.194.148.159", // Li
  "101.33.250.39": "http://101.33.250.39", // Li
  "119.91.48.139": "http://119.91.48.139", // Li
  "119.91.58.34": "http://119.91.58.34", // Li
  "42.193.130.202": "http://42.193.130.202", // Li
  "150.109.117.219": "http://150.109.117.219", // Li
  "119.28.73.52": "http://119.28.73.52", // Li
  "193.112.146.26": "http://193.112.146.26", // Li
  "43.155.13.226": "http://43.155.13.226",
  "43.129.64.215": "http://43.129.64.215",
  "150.109.61.55": "http://150.109.61.55",
  "101.32.177.157": "http://101.32.177.157",
  "47.243.93.168": "http://47.243.93.168",
  "47.239.136.97": "http://47.239.136.97",
  "119.28.31.200": "http://119.28.31.200",
  "129.226.121.148": "http://129.226.121.148",
  "47.83.153.10": "http://47.83.153.10",
  "cn2.hdxa1110.com": "http://cn2.hdxa1110.com", // Li
};

function isSecuredPath(path) {
  return securedPaths.includes(path);
}

function isRetryPath(url = "") {
  return retryPaths.some((path) => url.startsWith(path));
}

function isDomainAnIP() {
  const domain = document.domain;
  const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
  return ipRegex.test(domain);
}

function getBaseURL() {
  let bU = domainTitleMap[document.domain];

  if (isDomainAnIP()) {
    bU = document.location.origin;
  }

  return bU || "https://888.ffb252.com";
}

function getSearchParams() {
  return new URL(document.location.href).searchParams;
}

function getDeniedState() {
  try {
    return JSON.parse(localStorage.getItem("dlasdla"));
  } catch (e) {
    return null;
  }
}

function getNow() {
  return new Date().getTime();
}

function getUrlPath(url = "") {
  return String(url).split("?")[0];
}

function isGoUrlPage() {
  return router?.history?.current?.name === "goUrl";
}

function isLoginPage() {
  return router?.history?.current?.name === "userLogin";
}

function getAuthHeaders() {
  const params = getSearchParams();
  const headers = {};
  const queryId = params.get("id");
  const queryToken = params.get("token");
  const localToken = localStorage.getItem("token");

  if (queryId && queryToken) {
    headers.id = queryId;
    headers.Authorization = "Bearer " + queryToken;
    return headers;
  }

  headers.Authorization = "Bearer " + (localToken || "");
  return headers;
}

function applyDefaultHeaders(client) {
  const authHeaders = getAuthHeaders();
  Object.keys(authHeaders).forEach((key) => {
    client.defaults.headers.common[key] = authHeaders[key];
  });
}

function clearAuthHeaders(client) {
  client.defaults.headers.common.Authorization = "";
  delete client.defaults.headers.common.id;
}

function setGlobalLoading(loading) {
  store.dispatch("setLoadding", loading);
  store.dispatch("setWaitQuest", loading);

  if (!loading) {
    store.dispatch("setReload", false);
  }
}

async function fetchUserIp() {
  try {
    const res = await fetch("https://ip-api.com/json");
    const data = await res.json();
    return data?.query || "";
  } catch (e) {
    return "";
  }
}

function notifyError(message, extra = {}) {
  Notify({
    type: "danger",
    message,
    ...extra,
  });
}

function handleBlockedAccess() {
  notifyError("拒绝访问-" + (VueCookie.get("userIp") || ""));
  return Promise.reject(new Error("封鎖訪問"));
}

function handleUnauthorized(message) {
  store.dispatch("disconnectPusher");
  store.commit("CLEARNSELF");
  notifyError(message);

  clearAuthHeaders(axios);
  localStorage.removeItem("token");

  if (!isLoginPage()) {
    router.push("/userLogin");
  }
}

function markDeniedFor10Minutes() {
  const date = new Date();
  const min = date.getMinutes();

  VueCookie.set("dlasdla", "asdq123", { expires: "10m" });
  localStorage.setItem(
    "dlasdla",
    JSON.stringify({
      have: true,
      expires: date.setMinutes(min + 10),
    })
  );
}

const baseURL = getBaseURL();
axios.defaults.baseURL = baseURL;
applyDefaultHeaders(axios);

// 給 HMAC 用的獨立 client，避免攔截器遞迴
const hmacClient = axios.create({
  baseURL,
});
applyDefaultHeaders(hmacClient);

let requestSeed = 0;
const pendingRequests = new Map();

function addPending(config) {
  requestSeed += 1;
  const requestId = `req_${Date.now()}_${requestSeed}`;
  config.__requestId = requestId;
  pendingRequests.set(requestId, getUrlPath(config.url));
  setGlobalLoading(true);
}

function removePending(config) {
  const requestId = config?.__requestId;

  if (requestId && pendingRequests.has(requestId)) {
    pendingRequests.delete(requestId);
  }

  if (pendingRequests.size === 0) {
    setGlobalLoading(false);
  }
}

async function attachVerifyToken(config) {
  const urlPath = getUrlPath(config.url);

  if (!isSecuredPath(urlPath)) {
    return config;
  }

  try {
    const hmacRes = await hmacClient.get("/mobile/hmac", {
      headers: {
        ...getAuthHeaders(),
        "x-verify-path": urlPath,
      },
    });

    if (hmacRes?.data?.code === 0) {
      const token = hmacRes?.data?.data?.token;
      config.headers = config.headers || {};
      config.headers["x-verify-token"] = token;
      return config;
    }

    notifyError("驗證失敗，請稍後再試");
    return Promise.reject(new Error("HMAC 驗證失敗"));
  } catch (err) {
    notifyError("無法取得驗證資訊，請檢查網路");
    return Promise.reject(err);
  }
}

// 若熱更新或重複 import，先清掉舊 interceptor，避免重複註冊
if (window.__APP_AXIOS_REQ_INTERCEPTOR__ !== undefined) {
  axios.interceptors.request.eject(window.__APP_AXIOS_REQ_INTERCEPTOR__);
}
if (window.__APP_AXIOS_RES_INTERCEPTOR__ !== undefined) {
  axios.interceptors.response.eject(window.__APP_AXIOS_RES_INTERCEPTOR__);
}

window.__APP_AXIOS_REQ_INTERCEPTOR__ = axios.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};

    const authHeaders = getAuthHeaders();
    Object.keys(authHeaders).forEach((key) => {
      config.headers[key] = authHeaders[key];
    });

    if (
      store.state.selfData &&
      store.state.selfData.on_duty_ds &&
      config.url !== "/mobile/self"
    ) {
      store.dispatch("useIdleTimeout", true);
    }

    if (isGoUrlPage()) {
      return config;
    }

    const denied = getDeniedState();
    if (
      (VueCookie.get("dlasdla") && VueCookie.get("dlasdla") === "asdq123") ||
      (denied && denied.expires > getNow())
    ) {
      return handleBlockedAccess();
    }

    const verifiedConfig = await attachVerifyToken(config);
    addPending(verifiedConfig);
    return verifiedConfig;
  },
  (error) => {
    notifyError("网络异常,请联系客服");
    return Promise.reject(error);
  }
);

window.__APP_AXIOS_RES_INTERCEPTOR__ = axios.interceptors.response.use(
  async (res) => {
    removePending(res.config);

    if (res?.data?.code === codeList.BINDFA) {
      store.dispatch("bindFA", true);
    }

    if (res?.data?.code === 9999999) {
      const userIp = await fetchUserIp();
      if (userIp) {
        VueCookie.set("userIp", userIp);
      }
      markDeniedFor10Minutes();
    }

    if (res?.data?.code === 10001) {
      handleUnauthorized(res?.data?.message);
      return res;
    }

    if (res?.data?.code === 50000) {
      return res;
    }

    if (res?.data?.code !== 0) {
      notifyError(res?.data?.message);
      return res;
    }

    return res;
  },
  async (err) => {
    removePending(err?.config);

    try {
      const eee = err?.toJSON?.();
      if (eee?.code === "ECONNABORTED") {
        return Promise.reject(err);
      }
    } catch (e) {
      console.log(err);
    }

    if (!err?.response) {
      const requestUrl = err?.config?.url || err?.toJSON?.()?.config?.url || "";
      const errorMessage =
        err?.message || err?.toJSON?.()?.message || "Unknown error";
      const userIp = await fetchUserIp();

      if (userIp) {
        notifyError(
          `请先检查您的网络-${requestUrl}-${userIp}\n${errorMessage}`,
          {
            showClose: true,
          }
        );
      } else {
        notifyError(`请先检查您的网络-${requestUrl}\n${errorMessage}`, {
          showClose: true,
        });
      }

      setGlobalLoading(false);
      pendingRequests.clear();
      return Promise.reject(err);
    }

    const status = err.response.status;

    if (status === 500) {
      notifyError("连线失败", { showClose: true });
      return Promise.reject(err);
    }

    if (status === 429) {
      notifyError("请求次数过多，已达到限制速率门槛", {
        showClose: true,
      });
      return Promise.reject(err);
    }

    if (status === 430) {
      notifyError("操作速度太快了，请勿频繁刷新页面！", {
        showClose: true,
      });
      return Promise.reject(err);
    }

    return Promise.reject(err);
  }
);

// retry 三次
export async function axiosWithRetry(config, retryCount = 0) {
  const MAX_RETRIES = 3;
  const TIMEOUT = 3000;

  try {
    const res = await axios({
      ...config,
      timeout: TIMEOUT,
    });
    return res;
  } catch (err) {
    const isTimeout =
      err?.code === "ECONNABORTED" || err?.code === "ERR_CANCELED";

    const url = config?.url || "";

    if (isTimeout && isRetryPath(url) && retryCount < MAX_RETRIES) {
      console.warn(`⚠️ Retry #${retryCount + 1} for ${url}`);
      return axiosWithRetry(config, retryCount + 1);
    }

    return Promise.reject(err);
  }
}

Vue.prototype.$http = axios;
Vue.prototype.$httpRetry = axiosWithRetry;

export { axios };
export default axios;
